import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TOrganizationForm } from "@/features/organization/types/organizationForm";
import { InnerBox } from "@/modules/irohana-components/elements/InnerBox";
import { Grid } from "@mui/material";
import { FormField } from "@/modules/irohana-components/elements/FormField";
import { Input } from "@/modules/irohana-components/elements/Input";

export const BasicForm: FC = () => {
  const { control } = useFormContext<TOrganizationForm>();

  return (
    <InnerBox title="基本情報" p={3} bordered>
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={12}>
          <FormField control={control} name="name" label="組織名" required>
            <Input placeholder="入力してください" />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
